
























































































































import http from "@/axios/http-common";
import { refResepStore } from "@/store/modules/ReferensiResep";
import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";
import ObatSearchBox from "@/components/resep/ObatSearchBox.vue";

interface ItemObat {
  type: "single";
  obat_nama: string;
  qty: number;
  qty_unit: string;
  // signa: string;
  harga: number;
  countedHarga: number;
  obat_id: string;
  ap_rute: string;
  ap_frekuensi: string;
  ap_dosis: string;
  ap_dosis_unit: string;
  ap_tambahan: string;
  ap_template_id: string;
  ap_template_nama: string;
  r: string;
  frekuensi_id: string;
  rute_id: string;
  aturan_pakai: {
    id: string;
    nama: string;
  };
}

const currencyFormatter = new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR"
});

@Component({
  components: {
    ObatSearchBox
  }
})
export default class ObatItemResep extends Vue {
  public showObatSearch = false;
  public rules = {
    required: value => !!value || "Kolom ini harus diisi"
  };
  loading = false;
  items = [];
  val = "";
  // cekAturanPakai(val) {
  //   if (val) {
  //     return { id: val.ap_template_id, nama: val.ap_template_nama };
  //   } else {
  //     return { id: null, nama: null };
  //   }
  // }
  listAturanPakai = [];
  // search = null;
  select = null;
  // list = [{ val: null, search: null }];
  entries = [];
  signaLoading = false;
  _timerId;
  searchString = null;

  @Prop() item: ItemObat;

  @Prop() index: number;

  @Prop() color: string;

  @Ref() readonly obatSearchBox!: ObatSearchBox;
  @Ref() qty: HTMLInputElement;

  mounted() {
    this.$nextTick(() => {
      // this.item.ap_dosis_unit = this.item.qty_unit?.toLowerCase();
      // console.log(
      //   "mounted set dosis unit",
      //   this.item.ap_dosis_unit,
      //   this.item.qty_unit
      // );
      this.qty.focus();
    });
  }

  formatHarga(harga) {
    return currencyFormatter.format(harga);
  }

  countHarga(item: ItemObat) {
    item.countedHarga = item.qty * item.harga;
    this.$emit("sum-total-harga");
  }

  triggerSubmit() {
    this.$emit("trigger-submit");
  }

  removeItem(index) {
    console.log("remove from row", index);
    this.$emit("remove-item", index);
  }

  get refRute() {
    return refResepStore.refRute;
  }

  get refFrekuensi() {
    return refResepStore.refFrekuensi;
  }

  get refSediaan() {
    return refResepStore.refSediaan;
  }

  @Watch("searchString")
  searched() {
    this.listAturanPakai = [];
    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (this.searchString === null || this.searchString.length < 2) return;
      this.searchAturanPakai(this.searchString);
    }, 500);
  }

  searchAturanPakai(termSearch) {
    http
      .getDataParam(`/aturan-pakai/search`, {
        params: { term: termSearch }
      })
      .then(res => {
        this.listAturanPakai = res.data;
      })
      .finally();
  }

  // @Watch("item")
  // changedItem(val) {
  //   this.
  // }

  handleSelectObat(val) {
    // Update obat item with selected obat
    this.item.obat_nama = val.nama;
    this.item.obat_id = val.id;
    this.item.harga = val.harga;
    this.item.qty_unit = val.satuan;

    // Recalculate counted harga if qty exists
    if (this.item.qty) {
      this.item.countedHarga = this.item.qty * this.item.harga;
      this.$emit("sum-total-harga");
    }

    // Hide the search box
    this.showObatSearch = false;
  }

  @Watch("showObatSearch")
  changedShowObatSearch(show: boolean) {
    if (show) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.obatSearchBox.focus();
        });
      });
    }
  }

  // changeAturanPakai(val) {
  //   if (val) {
  //     // alert(this.item.obat_nama);
  //     // this.item.ap_template_nama = val.aturan_pakai.nama;
  //     // this.item.ap_template_id = val.aturan_pakai.nama;
  //     this.item.ap_template_nama = this.item.aturan_pakai.nama;
  //     this.item.ap_template_id = this.item.aturan_pakai.id;
  //     // this.$nextTick(() => {
  //     //   this.jml.focus();
  //     // });
  //   }
  // }
}
